import { LettersButton } from './letters/Letters';
import { NotesButton } from './notes/Notes';
import { TimelineButton } from './timeline/Timeline';
import { AlertsButton } from './Alerts';
import { SettingsButton } from './Settings';
import { WatchersButton } from './Watchers';

export default { timeline: TimelineButton, notes: NotesButton, alerts: AlertsButton, settings: SettingsButton, letters: LettersButton, watchers: WatchersButton };
